"use client";

import type { FC, ReactNode } from "react";
import { useContext } from "react";

import { ThemeSlotContext } from "../contexts/ThemeSlotContext";
import type {
  ThemeSlotKey,
  ThemeSlotPropsMap,
} from "../contexts/ThemeSlotContext";

type SlotProps<K extends ThemeSlotKey> = K extends keyof ThemeSlotPropsMap
  ? ThemeSlotPropsMap[K]
  : { children?: ReactNode };

/**
 * Returns the themed component for a slot key, or the default if not overridden
 */
export function useThemeSlot<K extends ThemeSlotKey>({
  key,
  defaultComponent,
}: {
  key: K;
  /**
   * Component to use when no override is registered for the current theme
   */
  defaultComponent: FC<SlotProps<K>>;
}): FC<SlotProps<K>> {
  const slots = useContext(ThemeSlotContext);
  return (slots[key] as FC<SlotProps<K>>) ?? defaultComponent;
}
